package ru.it_mozaika.sender.js.application.frames.senders

import js.core.ReadonlyRecord
import js.core.jso
import mui.icons.material.AddCircleOutlineSharp
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.components.senders.senderDialog
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.js.application.context.useStore
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*

val SendersListFrame = VFC {

    val storeContext = useStore()
    val stores = storeContext.storeList
    val senders = storeContext.sendersList
    val tableColumns = listOf("ID", "Наименование", "Магазин", "Email", "Email для ответа")
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (selectedSenders, setSelectedSenders) = useState<List<Sender>>(listOf())
    /**
     * Используется в диалоге
     * **/
    val (selectedSender, setSelectedSender) = useState<Sender>()
    val (showDialog, setShowDialog) = useState(false)
    val table = useReactTable<Sender>(
        options = jso {
            this.columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<Sender, Any?>> {
                        accessorFn = { sender, _ ->
                            when (column) {
                                "ID" -> sender.id
                                "Наименование" -> sender.name
                                "Магазин" -> stores.find { it.id == sender.id }?.name ?: sender.store
                                "Email" -> sender.email
                                "Email для ответа" -> sender.reply
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
//                            val id = context.row.getValue("ID").toString()
                            val value = context.getValue().toString()
                            Box.create {
                                +value
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }.toTypedArray()
            }
            this.data = useMemo(senders) { senders.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )

    senderDialog {
        this.isOpen = showDialog
        this.onClose = {
            setSelectedSender(null)
            setShowDialog(false)
        }
        this.sender = selectedSender
    }
    MainCard {
        title = "Отправители"
        actions = Stack.create() {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }

            AvatarButton {
                this.tooltipTitle = "Добавить отправителя"
                onClick = {
                    setSelectedSender(null)
                    setShowDialog(true)
                }
                AddCircleOutlineSharp()
            }
        }
        commonTableSkeletonFrame {
            this.showCheckBox = false
            this.currentSelected = selectedSenders.map { it.id }
            this.toolbarActions = Stack.create() {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
            }
            this.label = "senders"
            this.propertiesFilter = listOf()
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = { id ->
                val sender = senders.find {
                    it.id == id
                }
                setSelectedSender(sender)
                setShowDialog(true)
            }
            this.onPropertySelect = {}
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { id ->
                    senders.find { sender ->
                        sender.id == id
                    }
                }
                setSelectedSenders(newList)
            }
        }
    }
}